export default {
    CONTENT_TYPE: 'Content-Type',
    AUTH_KEY: 'Authorization',
    MIME: {
        text: 'text/plain',
        json: 'application/json'
    },
    DEFAULT_TIMEOUT: 60 * 1000,
    MMB_URL: process.env.VUE_APP_MMB_URL,
    IBE_URL: process.env.VUE_APP_IBE_URL,
    B2B_API_URL: process.env.VUE_APP_B2B_API_URL,
    STAFF_API_URL: process.env.VUE_APP_STAFF_API_URL,
    STAFF_SSO_URL: process.env.VUE_APP_STAFF_SSO_URL,
    TIGERAIRTW_URL: process.env.VUE_APP_TIGERAIRTW_URL,
    TRANSLATION_URL: process.env.VUE_APP_TRANSLATION_URL,
    GOOGLE_CLIENT_ID: process.env.VUE_APP_GOOGLE_CLIENT_ID
};